const actions = {
  getUsuarios: async (
    context,
    { vendor_id, page, per_page, search, aceite_biometria }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`auth/users`, {
      params: {
        vendor_id,
        page,
        per_page,
        search,
        aceite_biometria,
      },
    });

    return response;
  },
  uploads: async (context, { mapeamento, planilha, unidade }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/manutencao-planilha`, {
      adicional: {
        vendor_id: unidade,
      },
      mapeamento,
      planilha,
    });

    return response;
  },

  // Criar, Editar e Criar

  listarCatalogos: async (context, { per_page }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`contracts`, {
      params: {
        per_page,
      },
    });

    return response;
  },

  filtrarCatalogo: async (context, { per_page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`vendors/users`, {
      params: {
        per_page,
        search,
      },
    });

    return response;
  },

  // Gestão Catálogos

  listarProdutosCatalogo: async (
    context,
    { vendor_id, epi, per_page, search, page }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`contracts/${vendor_id}/products`, {
      params: {
        per_page,
        page,
        epi,
        search,
      },
    });
    return response;
  },

  listarTodosProdutos: async (context, { search, page, per_page }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`products`, {
      params: {
        search,
        per_page,
        page,
      },
    });
    return response;
  },

  listarCategorias: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`product-categories`);

    return response;
  },

  listarGrupos: async (context, { vendor_id, per_page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`product-groups`, {
      params: {
        per_page,
        vendor_id,
        search,
      },
    });

    return response;
  },

  adicionarProdutoCatalogo: async (
    context,
    {
      catalog_id,
      ca_id,
      cofins,
      contract_product_description,
      icms,
      isEpi,
      pis,
      product_category_id,
      product_id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`contracts/${catalog_id}/products`, {
      products: [
        {
          ca_id,
          cofins,
          contract_product_description,
          icms,
          isEpi,
          pis,
          product_category_id,
          product_id,
        },
      ],
      catalog_id,
    });

    return response;
  },
  alterarEstadoEpi: async (context, { contract_id, isEpi, product_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`contracts/${contract_id}/change-is-epi`, {
      products: [
        {
          product_id,
          isEpi,
        },
      ],
    });

    return response;
  },
  removerProduto: async (context, { contract_id, product_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(
      `contracts/${contract_id}/products/${product_id}`
    );
    return response;
  },

  atualizarProduto: async (
    context,
    { catalog_id, contract_product_description, price, product_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`contracts/${catalog_id}/products`, {
      catalog_id,
      products: [{ contract_product_description, price, product_id }],
    });

    return response;
  },

  adicionarGrupoProduto: async (
    context,
    { catalog_id, product_id, product_group_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`contracts/${catalog_id}/products`, {
      catalog_id,
      products: [{ product_group_id, product_id }],
    });

    return response;
  },

  criarProduto: async (context, { code, description, name }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`products`, {
      code,
      description,
      name,
    });

    return response;
  },

  // Editar Produto

  listarDetalhesProduto: async (context, { vendor_id, product_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `vendors/${vendor_id}/products/${product_id}`
    );

    return response;
  },

  ajustarProduto: async (context, { vendor_id, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`vendors/${vendor_id}/adjust-products`, {
      products: [{ id }],
    });

    return response;
  },

  atualizarInfosBase: async (
    context,
    {
      catalog_id,
      contract_product_description,
      price,
      product_id,
      product_category_id,
      product_group_id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`contracts/${catalog_id}/products`, {
      products: [
        {
          contract_product_description,
          price,
          product_id,
          product_category_id,
          product_group_id,
        },
      ],
    });
    return response;
  },

  atualizarInfosBaseCategoria: async (
    context,
    { catalog_id, product_id, product_category_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`contracts/${catalog_id}/products`, {
      products: [
        {
          product_id,
          product_category_id,
        },
      ],
    });
    return response;
  },

  atualizarInfosBaseGrupo: async (
    context,
    { catalog_id, product_id, product_group_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`contracts/${catalog_id}/products`, {
      products: [
        {
          product_id,
          product_group_id,
        },
      ],
    });
    return response;
  },

  atualizarInfosFiscais: async (
    context,
    { contract_id, cfop, cofins, icms, pis, product_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`contracts/${contract_id}/products`, {
      products: [{ cfop, cofins, icms, pis, product_id }],
    });
    return response;
  },

  atualizarCestNcm: async (context, { product_id, cest, ncm }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`products/${product_id}`, {
      cest,
      ncm,
    });
    return response;
  },

  atualizarInfosCompras: async (
    context,
    {
      vendor_id,
      address,
      conta_contabil,
      id,
      lead_time,
      max_amount,
      measurement_unit,
      measurement_unit_description,
      minimal_amount,
      replacement_amount,
      ultimo_fornecedor_id,
      contrato_fornecedor,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`vendors/${vendor_id}/adjust-products`, {
      products: [
        {
          address,
          conta_contabil,
          id,
          lead_time,
          max_amount,
          measurement_unit,
          measurement_unit_description,
          minimal_amount,
          replacement_amount,
          ultimo_fornecedor_id,
        },
      ],
    });

    // Se contrato_fornecedor foi fornecido, atualizar usando o endpoint específico
    if (contrato_fornecedor !== undefined && contrato_fornecedor !== null) {
      await api.put(`/products/${id}/contrato-fornecedor`, {
        product_id: id,
        vendor_id,
        contrato: contrato_fornecedor,
      });
    }

    return response;
  },

  alterarControleLote: async (context, { vendor_id, id, batch_control }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`vendors/${vendor_id}/adjust-products`, {
      products: [
        {
          batch_control,
          id,
        },
      ],
    });

    return response;
  },

  filtrarFornecedores: async (context, { search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`providers`, {
      params: {
        search,
        per_page: 10,
      },
    });

    return response;
  },
};

export const catalogo = {
  namespaced: true,
  actions,
};
